import { Component, Suspense } from 'react';
import { Provider } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import AccessForbidden from 'components/403';
import NotFound from 'components/404';
import Main from 'components/Main';
import ApplicationLoading from 'components/system/ApplicationLoading';
import Home from 'components/user/Home';
import SelectPort from 'components/user/SelectPort';
import User from 'components/user/User';
import { NAVIGATIONS, VIEW_MODE } from 'data/static';
import { withRouter } from 'utils/withRouter';

import store from './store';

// Define Props for the component
interface AppProps {
    navigate: (path: string) => void; // Navigation function
}

// Define State for the component
interface AppState {
    token: string | null; // Token can be a string or null
}

class App extends Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);
        this.state = {
            token: localStorage.getItem('token'), // Initialize state with token
        };
        window.toast = toast;
    }

    render() {
        return (
            <>
                <Suspense fallback={<ApplicationLoading />}>
                    <Provider store={store}>
                        <ToastContainer autoClose={5000} />
                        <Routes>
                            {/* Redirect "/" to "/chart" */}
                            <Route
                                path="/"
                                element={
                                    <Navigate
                                        to={
                                            this.state.token
                                                ? VIEW_MODE === 'live'
                                                    ? '/time'
                                                    : `/${VIEW_MODE}`
                                                : `/home`
                                        }
                                        replace
                                    />
                                }
                            />
                            <Route path="/user/:tab/:token/:uuid" element={<User />} />
                            <Route path="/home" element={<Home />} />
                            <Route path="/login" element={<Home />} />

                            <Route path="/user/selectPort" element={<SelectPort />} />
                            {/* Define valid routes */}
                            {NAVIGATIONS.filter((x) => {
                                return this.state.token !== '' && this.state.token !== null;
                            }).map((x) => {
                                if (x === 'savedChart') {
                                    return <Route key={x} path={'chart/:uuid'} element={<Main />} />;
                                }
                                return <Route key={x} path={x} element={<Main />} />;
                            })}

                            {NAVIGATIONS.filter((x) => {
                                return this.state.token === '' || this.state.token === null;
                            }).map((x) => {
                                return <Route key={x} path={x} element={<AccessForbidden />} />;
                            })}

                            {/* Catch-all route for anything else */}
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Provider>
                </Suspense>
            </>
        );
    }
}

export default withRouter(App);
